const RESUME_CACHE_KEY = 'hh_full_resumes_cache_v2';
const RESUME_CACHE_ORDER_KEY = 'hh_full_resumes_cache_order_v2';

function isQuotaError(error: unknown): boolean {
  const anyErr = error as any;
  const name = String(anyErr?.name || '');
  return (
    name === 'QuotaExceededError' ||
    name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
    anyErr?.code === 22 ||
    anyErr?.code === 1014
  );
}

function safeJsonParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

function evictOldestResumeEntries(count: number): boolean {
  try {
    const order = safeJsonParse<string[]>(localStorage.getItem(RESUME_CACHE_ORDER_KEY)) || [];
    const cache = safeJsonParse<Record<string, any>>(localStorage.getItem(RESUME_CACHE_KEY)) || {};
    if (order.length === 0) return false;

    const toEvict = order.slice(0, Math.max(0, count));
    if (toEvict.length === 0) return false;

    for (const id of toEvict) {
      delete cache[id];
    }
    const nextOrder = order.slice(toEvict.length);

    localStorage.setItem(RESUME_CACHE_KEY, JSON.stringify(cache));
    localStorage.setItem(RESUME_CACHE_ORDER_KEY, JSON.stringify(nextOrder));
    return true;
  } catch {
    return false;
  }
}

function removeKey(key: string): boolean {
  try {
    if (localStorage.getItem(key) == null) return false;
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

function freeSomeSpace(): boolean {
  if (evictOldestResumeEntries(20)) return true;

  const evictKeys = [
    'hr-crm-editor-pages-v1',
    'recruiter_state_v1',
    'branding:logo:dataurl:v1',
    'branding:logo:meta:v1',
    'branding:v1',
    'branding_storage_v1',
  ];

  for (const key of evictKeys) {
    if (removeKey(key)) return true;
  }

  return false;
}

export function safeLocalStorageSetItem(key: string, value: string): boolean {
  if (typeof window === 'undefined') return false;
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    if (!isQuotaError(error)) return false;

    for (let i = 0; i < 8; i++) {
      if (!freeSomeSpace()) break;
      try {
        localStorage.setItem(key, value);
        return true;
      } catch (err2) {
        if (!isQuotaError(err2)) return false;
      }
    }
    return false;
  }
}

export function safeLocalStorageSetJson(key: string, data: unknown): boolean {
  try {
    return safeLocalStorageSetItem(key, JSON.stringify(data));
  } catch {
    return false;
  }
}
